import type { MDXContent } from 'mdx/types';

import { Wrapper, type WrapperComponent } from './Wrapper.tsx';
import { DEFAULT_SIZE } from './size.ts';

export const WrapperRenderer = ({
  children,
  document: Document,
}: {
  children: WrapperComponent;
  document: MDXContent;
}) => (
  <Document
    components={{
      Layout: ({ children: content }) => (
        <Wrapper component={children} size={DEFAULT_SIZE}>
          {content}
        </Wrapper>
      ),
    }}
  />
);
